import { render, staticRenderFns } from "./BusinessApplicationsList.vue?vue&type=template&id=cbe9d1ca&scoped=true"
import script from "./BusinessApplicationsList.vue?vue&type=script&lang=js"
export * from "./BusinessApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./BusinessApplicationsList.vue?vue&type=style&index=0&id=cbe9d1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe9d1ca",
  null
  
)

export default component.exports